<template>
  <div class="managementList">
    <div class="btn_ctl">
      <el-button size="mini" type="primary" @click="newPage">新增企业印章</el-button>
    </div>
      <div class="content">
        <ab-table
          class="table"
          ref="table"
          stripe
          showEdit
          widths="155"
          :column-list="columns"
          :table-list="tableData"
          :dataListLoading="tableLoading"
        >
          <template #url="scope">
            <div class="img">
              <img :src="scope.row.url" />
            </div>
          </template>

          <template #operator="scope">
            <div class="operator">
              <!-- <el-button type="text" @click="editSeal(scope.row)">编辑</el-button> -->
              <el-button v-if="!scope.row.isDefault" class="delete-list" type="text" @click="removeRow(scope.row)">删除</el-button>
              <div v-if="scope.row.isDefault" class="default">默认印章</div>
            </div>
          </template>
        </ab-table>
      </div>
    <!-- <div class="title1">印章管理</div> -->
  </div>
</template>

<script>
export default {
  name: 'seal-managementList', // 印章管理
  data () {
    return {
      tableLoading: false,

      columns: [
        {
          props: 'sealId',
          labels: '印章编号',
          widths: 240
        },
        {
          props: 'url',
          labels: '印章',
          slot: 'slot',
          align: 'center',
          widths: 100
        },
        {
          props: 'sealName',
          labels: '印章名称',
          widths: 170
        },
        // {
        //   props: 'status',
        //   labels: '状态',
        //   widths: 80
        // }
      ],
      tableData: [],

      routeQuery: {}
    }
  },
  activated () {
    this.getTableData()
  },
  mounted () { // 临时修改
    this.getTableData()
  },
  methods: {
    getTableData () {
      this.tableLoading = true
      this.$post('/sys/esignSeal/list', { data: {}, pageNum: 1, pageSize: 9999 })
        .then(({ data }) => {
          if (data.code === 'C0000') {
            this.tableData = data.result.list
          } else {
            this.$message.error(data.message)
          }
        })
        .catch(err => {
          console.error(err)
          this.$message.error('服务器正忙，请稍后再试')
        })
        .finally(() => {
          this.tableLoading = false
        })
    },
    newPage () {
      if (this.routeQuery.isIframe) {
        this.$router.push({
          path: '/company-iframe',
          query: {
            cache: false,
            isIframe: true
          }
        })
      } else {
        this.$router.push({
          path: '/company'
        })
      }
    },
    // editSeal (row) {
    //   this.$router.push(
    //     {
    //       path: '/seal/company-edit',
    //       query: {
    //         data: row,
    //         cache: false
    //       }
    //     }
    //   )
    // },
    removeRow (row) {
      this.$confirm('此操作将永久删除该印章, 是否继续?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.tableLoading = true
        this.$post('/sys/esignSeal/del', { id: row.id })
          .then(({ data }) => {
            if (data.code === 'C0000') {
              this.$message.success(data.message)
            } else {
              this.$message.error(data.message)
            }
          })
          .catch(err => {
            console.error(err)
            this.$message.error('服务器正忙，请稍后再试')
          })
          .finally(() => {
            this.getTableData()
          })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.managementList {
  // padding: 30px;
  background: #fff;
  // border: 1px solid rgba(221, 226, 235, 1);
  .content{
    margin-top: 8px;
    padding: 30px;
  }
  .btn_ctl {
    text-align: left;
    padding: 10px 30px 10px 30px;
    border-bottom: 1px solid #e4e4e4;
  }
  .img {
    padding: 9px 0;
    img {
      width: 113px;
      height: 111px;
    }
  }

  .operator {
    font-size: 0;
    display: flex;

    .default {
      position: absolute;
      top: 50px;
      right: 0px;
      width: 78px;
      height: 28px;
      background: linear-gradient(
        90deg,
        rgba(0, 178, 243, 1) 0%,
        rgba(0, 126, 222, 1) 100%,
        rgba(0, 104, 183, 1) 100%,
        rgba(0, 104, 183, 1) 100%
      );
      border-radius: 100px 0px 0px 100px;
      font-size: 12px;
      color: #fff;
      font-weight: 500;
      line-height: 28px;
      text-align: center;
    }
  }
}
</style>
